const initial_state = {
  color: {
    primary_color   : '#41436A' ,
    secondary_color : '#31b2f7' ,
  }
};

export default (state = initial_state, action) => {
  switch (action.type) {
    default: return { ...state };
  }
}
